<div>
  <section class="row" style="font-weight: bold">

    <label class="col-6">
      {{''|i18n:'select-the-contract-type'}}
    </label>
    <label class="col-2" style="float: right">
      {{''|i18n:'end-date'}}
    </label>
  </section>
  <form [formGroup]="form" class="row">
    <div class="col-2">
      <div class="row">
        <input class="col-2" type="radio" value="NONE" (change)="emit()"
          formControlName="contractType">
          <label>{{''|i18n:'none'}}</label>
        </div>

      </div>
      <div class="col-2">
        <div class="row">
          <input class="col-2" type="radio" value="07CG" (change)="emit()"
            formControlName="contractType">
            <label>{{''|i18n:'07CG'}}</label>

          </div>
          @if (!form.get('contractType').valid) {
            <app-error-field
            [errorMessage]="'please-choose-a-contract-type'"></app-error-field>
          }
        </div>
        <div class="col-2">
          <div class="row">
            <input class="col-2" type="radio" value="07CH" (change)="emit()" formControlName="contractType">
            <label>{{''|i18n:'07CH'}}</label>
          </div>

        </div>
        <div class="col-2">
          <input type="date" (keydown)="disable()" aria-invalid="true" max="2029-12-31" min="2010-01-01"
            (input)="emit()" formControlName="endDate">
            @if (!form.get('endDate').valid) {
              <app-error-field
              [errorMessage]="'please-enter-a-valid-date'"></app-error-field>
            }
          </div>
        </form>
      </div>

